import { getSteps } from './steps';
import { useControlPortalWelcomeExperience } from './use-advance-tour-guide';

export const portalWelcomeExperienceData = { useControlPortalWelcomeExperience, getSteps };
